import EnquiryPageShell from '@/components/feature/EnquiryPageShell';
import EnquiryForm from '@/components/feature/EnquiryForm';
import { Field, TextareaField, SelectField } from '@/components/base/FormFields';

export default function EventRescue() {
  return (
    <EnquiryPageShell
      eyebrow="48-Hour Event Rescue"
      title="Request 48-Hour Event Rescue"
      intro={
        <>
          <p>
            For urgent, unusual or difficult requests. Daniella first reviews and agrees your brief,
            then sends payment instructions if it&rsquo;s accepted.
          </p>
          <p>
            If accepted, this service includes targeted sourcing and outreach. The 48-hour
            commitment means suitable options or a meaningful progress update within 48 actual
            elapsed hours from the agreed start time — it does not guarantee a supplier match,
            supplier availability or a booking.
          </p>
          <p>
            If you have a particularly urgent deadline, please explain it in the fields below so
            Daniella can consider it when reviewing your brief.
          </p>
        </>
      }
      price="£79"
      priceNote="Subject to approval — payment link sent only after your brief is reviewed and accepted."
    >
      <EnquiryForm
        submitAddr="https://readdy.ai/api/form/db6hqckbe24agvuu3jq0"
        formId="event_rescue"
        categoryMode="single"
        submitLabel="Submit My Rescue Request"
        priceNote="£79, subject to approval. No automatic checkout — Daniella will send payment instructions only after your brief is reviewed and accepted, at which point the 48 actual elapsed hours begin from the agreed start time."
        successMessage="Thank you — your rescue request has been received for Daniella's review. If accepted, she'll send payment instructions and the agreed start time."
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <Field
            label="Your deadline"
            name="deadline"
            type="date"
            required
            hint="The date by which you need a solution."
          />
          <SelectField
            label="Flexible on date or location?"
            name="flexibility"
            options={['Yes — flexible on both', 'Flexible on date only', 'Flexible on location only', 'No — fixed']}
            required
          />
        </div>
        <TextareaField
          label="What have you tried so far?"
          name="what_have_you_tried"
          required
          rows={3}
          placeholder="Tell us who or what you've already approached."
        />
        <TextareaField
          label="Why is this urgent or difficult?"
          name="why_urgent"
          required
          rows={3}
          placeholder="Help us understand the challenge and any constraints."
        />
      </EnquiryForm>
    </EnquiryPageShell>
  );
}